import { Flow } from './config'

export enum WizardFlowType {
  RLE,
  IBW,
  SOLAR,
}

export const mapFromWizardFlowTypeToFlow = (wizardFlowType: WizardFlowType): Flow => {
  switch (wizardFlowType) {
    case WizardFlowType.RLE:
      return Flow.RLE
    case WizardFlowType.IBW:
      return Flow.IBW
    case WizardFlowType.SOLAR:
      return Flow.SOLAR
  }
}
